import { useTranslation } from "@redotech/redo-i18n";
import Printer from "@redotech/redo-icons/printer.svg";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import { Trackable, TrackableType } from "@redotech/redo-model/trackable";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { useMemo } from "react";
export function LabelButtons({
  trackable,
  carrier,
  commercialInvoice,
}: {
  trackable: Trackable & { type: TrackableType.RETURN };
  carrier: string | undefined;
  commercialInvoice: string | null | undefined;
}) {
  const { t } = useTranslation();
  function openUrl(url: string) {
    window.open(url, "_blank");
  }

  const labelButtons = useMemo(() => {
    if (trackable.shipments?.length) {
      return trackable.shipments
        .filter((shipment) => !!shipment?.postage_label)
        .map((shipment) => {
          const originalIndex = trackable.shipments!.indexOf(shipment);
          return (
            <RedoButton
              hierarchy="secondary"
              IconLeading={Printer}
              key={originalIndex}
              onClick={() => openUrl(shipment.postage_label!)}
              text={
                trackable.shipments?.length && trackable.shipments?.length > 1
                  ? t("Print label {{labelNumber}}", {
                      labelNumber: originalIndex + 1,
                    })
                  : t("Print label")
              }
              uiSelector="print-label-button"
            />
          );
        });
    }
    return null;
  }, [t, trackable.shipments]);

  const qrButtons = useMemo(() => {
    if (!trackable.pickup && carrier !== "UPS" && trackable.shipments?.length) {
      return trackable.shipments
        .filter((shipment) => !!shipment?.form_label)
        .map((shipment) => {
          const originalIndex = trackable.shipments!.indexOf(shipment);
          return (
            <RedoButton
              hierarchy="secondary"
              IconLeading={QrCode}
              key={originalIndex}
              onClick={() => openUrl(shipment.form_label!)}
              text={
                trackable.shipments?.length && trackable.shipments?.length > 1
                  ? t("QR code {{labelNumber}}", {
                      labelNumber: originalIndex + 1,
                    })
                  : t("QR code")
              }
              uiSelector="qr-code-button"
            />
          );
        });
    }
    return null;
  }, [t, trackable.shipments, trackable.pickup, carrier]);

  return (
    <Flex data-ui="label-buttons" flexDirection="row" gap="sm" grow={1} pt="xs">
      {labelButtons}
      {qrButtons}
      {!!commercialInvoice && (
        <RedoButton
          hierarchy="secondary"
          onClick={() => openUrl(commercialInvoice)}
          text={t("Print commercial invoice")}
          uiSelector="print-invoice-button"
        />
      )}
    </Flex>
  );
}
